import React from "react";
import classes from "./Book.css";

import socialFacebook from "../../assets/images/social-icons/facebook.png";
import socialInstagram from "../../assets/images/social-icons/instagram.png";
//import socialTwitter from '../../assets/images/social-icons/twitter.png';
const url = "https://mr17.gettimely.com/book";

const book = (props) => {
    const bookButtonClick = () => {
        var win = window.open(url, "_blank");
        win.focus();
    };

    const hours = [
        { day: "Monday", hours: "9:00am - 5:30pm" },
        { day: "Tuesday", hours: "9:00am - 5:30pm" },
        { day: "Wednesday", hours: "9:00am - 7:00pm" },
        { day: "Thursday", hours: "9:00am - 7:00pm" },
        { day: "Friday", hours: "9:00am - 5:30pm" },
        { day: "Saturday", hours: "9:00am - 4:00pm" },
        { day: "Sunday", hours: "9:00am - 4:00pm" },
    ];

    return (
        <div className={classes.Book}>
            <button onClick={bookButtonClick}>BOOK ONLINE</button>
            <h3 style={{ marginBottom: "15px" }}>
                Opening Hours (Open 7 days!)
            </h3>
            <div className={classes.Hours}>
                <ul>
                    {hours.map(({ day, hours }) => {
                        return (
                            <li>
                                {day}
                                <span style={{ float: "right" }}>{hours}</span>
                            </li>
                        );
                    })}
                </ul>
            </div>
            <div className={classes.location}>
                <h3>Location</h3>
                <p>
                    613 Mt Eden Rd
                    <br />
                    Mt Eden
                    <br />
                    Auckland
                    <br />
                    <a href="tel://096303674">09 630 3674</a>
                    <br />
                </p>
            </div>

            <div className={classes.social}>
                <a
                    className={classes.socialicon}
                    href="https://www.facebook.com/Moes.co.nz/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img alt="facebook" src={socialFacebook} />
                </a>
                <a
                    className={classes.socialicon}
                    href="https://www.instagram.com/moesbarbernz/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img alt="instagram" src={socialInstagram} />
                </a>
            </div>
        </div>
    );
};

export default book;



// WEBPACK FOOTER //
// ./src/components/Book/Book.js